module.exports = __webpack_public_path__ + "img/background-lg.c33e4d74.svg";